import React from "react";
import { Link } from "react-router-dom";
import BreadcrumbContainer from "./styles";

export interface BreadcrumbItem {
  label: string;
  link?: string;
  active?: boolean;
  isTag?: boolean;
  state?: any;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <BreadcrumbContainer aria-label="Breadcrumb">
      {items.map((item, index) => (
        <React.Fragment key={item.label}>
          <div
            className={`breadcrumb-item ${item.active ? "active" : ""} ${
              item.isTag ? "tag" : ""
            }`}
          >
            {item.link && !item.active ? (
              <Link to={item.link} state={item.state}>
                {item.label}
              </Link>
            ) : (
              <span>{item.label}</span>
            )}
          </div>
          {index < items.length - 1 && <span className="separator" />}
        </React.Fragment>
      ))}
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;
